import LogoSmall from 'logo/logo-small.svg';
import Logo from 'logo/logo.svg';
import { FormattedMessage } from 'react-intl';

import * as S from './styles';

const LoadingPage: React.FC = () => {
  return (
    <S.ImgContainer>
      <S.BackgroundImg>
        <S.DivImg>
          <Logo />
        </S.DivImg>
        <S.Title>
          <FormattedMessage id="SIDEBAR_MENU.TITLE" />
        </S.Title>
      </S.BackgroundImg>

      <S.SmallLogoWrapper>
        <LogoSmall />
      </S.SmallLogoWrapper>
    </S.ImgContainer>
  );
};

export default LoadingPage;
